import * as React from "react";
import DebtPersonSvg from "src/assets/debt-person.svg";
import DebtWeightSvg from "src/assets/debt-weight.svg";

interface IProps {
  title: string;
  text: string;
  amount: string;
}

class DebtWidgetComparison extends React.PureComponent<
IProps
> {

  public render() {

    return (
      <div className="c-debt-compare">
        <div className="c-debt-compare__media">
          <img
            className="c-debt-compare__person"
            src={ DebtPersonSvg }
            alt=""
          />
          <img
            className="c-debt-compare__weight"
            src={ DebtWeightSvg }
            alt={ this.props.title }
          />
          <div className="c-debt-compare__amount">${ this.props.amount }</div>
        </div>
        <div className="c-debt-compare__content mt-3">
          <h3 className="c-debt-compare__title">{ this.props.title }</h3>
          <p><span className="c-debt-compare__amount">${ this.props.amount }</span> { this.props.text }</p>
        </div>
      </div>
    );
  }
}

export default DebtWidgetComparison;



// WEBPACK FOOTER //
// ./src/components/report/councilFinances/DebtWidgetComparison.tsx